function createLogger(type: 'log' | 'warn' | 'error' | 'debug') {
	return (...args: Parameters<typeof console.log>) =>
		console[type]('%c[ADVERT]%c', 'color:#fff;background:#cb1e7b;', '', ...args);
}


export default {
	log: createLogger('log'),
	warn: createLogger('warn'),
	error: createLogger('error'),
	debug: createLogger('debug')
};
